var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_31225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.38662V7.99995C14.6645 9.43756 14.199 10.8364 13.3383 11.9878C12.4775 13.1393 11.2676 13.9816 9.88894 14.3892C8.51032 14.7968 7.03687 14.7479 5.68835 14.2497C4.33982 13.7515 3.18847 12.8307 2.406 11.6247C1.62354 10.4186 1.25189 8.99199 1.34648 7.55749C1.44107 6.12299 1.99684 4.7575 2.93088 3.66467C3.86493 2.57183 5.12722 1.81021 6.52949 1.49338C7.93176 1.17656 9.39888 1.32151 10.712 1.90662",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66663L8 9.33996L6 7.33996",
    stroke: "#96999C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_31225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f10353ddc4a0545a8096c747ebe69c14.svg";
export { ForwardRef as ReactComponent };